import React, { CSSProperties } from 'react'
import { Center, Column, Expaned, Row } from '../layout/layout'
import { createUseStyles } from 'react-jss'
import { InkWell } from '../inkwell/inkwell'

const useStyles = createUseStyles({
    baseDialogBg: {
        height: '100%',
        width: '100%',
        background: 'rgba(0,0,0,0.50)',
    },

    dialogContent: {
        minWidth: '520px',
        background: '#FFFFFF',
        borderRadius: '10px',
        overflow: 'hidden',
    },

    dialogHeader: {
        height: '50px',
    },
})

export const BaseDialog: React.FC<{
    isShow: boolean
    styles?: CSSProperties
    title?: string
    width?: number
    onClose?: () => void
    renderTitle?: () => React.ReactNode
}> = props => {
    const styles = useStyles(props)

    return (
        <Center className={styles.baseDialogBg}>
            <Column
                className={styles.dialogContent}
                style={
                    !props.width
                        ? props.styles
                        : {
                              ...props.styles,
                              minWidth: `${props.width}px`,
                          }
                }
            >
                <Row data-align-items-center className={styles.dialogHeader}>
                    <Expaned data-row data-align-items-center data-padding-left-16>
                        <span data-color-000 data-font-size-16>
                            {props.title || '提示'}
                        </span>
                        {props.renderTitle && props.renderTitle()}
                    </Expaned>
                    <InkWell
                        data-height-50
                        data-width-50
                        data-center
                        data-cursor-pointer
                        onClick={() => props.onClose && props.onClose()}
                    >
                        <i className="iconfont icon6guanbi-20"></i>
                    </InkWell>
                </Row>
                {props.children}
            </Column>
        </Center>
    )
}
